/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { formatCurrency } from '../../Functions';
import { getDetailPagoConsulta } from "../../Api";
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import TableDetailHMQ from "./TableDetailHMQ";
import TableDetailConsulta from "./TableDetailConsulta";
import Axios from "axios";
import GlobalLoading from '../../components/GlobalLoading';

const QueryDetail = (props) => {

  const {razonsocial, fechaproceso, resumen_input_tipo_pago, resumen_input_prestador, resumen_input_fecha} = props;
  const [state, setState] = useState({
    data_pago_consulta: [],
    loading: true
  });
  const [loadingFile, setLoadingFile] = useState({ show: false, message: '' });
  const url = process.env.REACT_APP_API_URL;

  const _getDetailPagoConsulta = async () => {
    
    if (!resumen_input_tipo_pago) {
      return;
    }

    const _response = await getDetailPagoConsulta({
      resumen_input_tipo_pago:resumen_input_tipo_pago,
      resumen_input_prestador:resumen_input_prestador,
      resumen_input_fecha:resumen_input_fecha,
    });
    if (_response.status) {
      setState({
        data_pago_consulta: _response.data,
        loading: false,
      });
    }
  }

  const _downloadPDF = async () => {

    setLoadingFile({ show: true, message: 'GENERANDO PDF' });
    Axios({
      url: `${url}/auth/detallepagos/reportePDF?resumen_input_fecha=${resumen_input_fecha}&resumen_input_prestador=${resumen_input_prestador}&resumen_input_tipo_pago=${resumen_input_tipo_pago}`,
      method: "GET",
      responseType: "blob", // important
      headers: {
        Authorization:
        `Bearer ${localStorage.getItem('t')}`
      },
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${Date.now()}.pdf`);
      document.body.appendChild(link);
      link.click();
    }).finally(() => {
      setLoadingFile({ show: false, message: '' });
    });
  }

  const _downloadEXCEL = async () => {

    setLoadingFile({ show: true, message: 'GENERANDO EXCEL' });
    Axios({
      url: `${url}/auth/detallepagos/reportePDF?excel=1&resumen_input_fecha=${resumen_input_fecha}&resumen_input_prestador=${resumen_input_prestador}&resumen_input_tipo_pago=${resumen_input_tipo_pago}`,
      method: "GET",
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('t')}`
      },
    }).then((response) => {
      if(response.data.status){
        const link = document.createElement("a");
        link.href = response.data.file;
        link.setAttribute('download', `${Date.now()}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        alert('No se generó el archivo');
      }
    }).finally(() => {
      setLoadingFile({ show: false, message: '' });
    });
  }

  useEffect(() => {
    _getDetailPagoConsulta();
  }, [props])

  return (
    <>
      <GlobalLoading show={loadingFile.show} message={loadingFile.message} />
      <div className="row">
        <div className="col-12">
          <p>Nombre Profesional : {razonsocial}</p>
          <p>Fecha de Proceso : {fechaproceso}</p>
        </div>
      </div>
      {!state.loading && (
        <>
          <div className="row">
            {resumen_input_tipo_pago === "1" ? <TableDetailHMQ fechaproceso={fechaproceso} /> : <TableDetailConsulta fechaproceso={fechaproceso} /> }
          </div>
          <div className="row" style={{ marginBottom: '20px', marginTop: '20px' }}>
            <div className="col-12" style={{textAlign: 'right', paddingRight: '40px'}}>
              <button className="icon-button btn btn-outline btn-outline-primaryamsm btn-active-light-primary" onClick={() => _downloadEXCEL()} style={{marginRight: '10px'}}>
                <div className="icon-container">
                  <span>EXCEL</span>
                  <img src={toAbsoluteUrl('/media/icons/732220.png')} alt="Descarga Excel" />
                </div>
              </button>

              <button className="icon-button btn btn-outline btn-outline-primaryamsm btn-active-light-primary" onClick={() => _downloadPDF()}>
                <div className="icon-container">
                  <span>PDF</span>
                  <img src={toAbsoluteUrl('/media/icons/337946.png')} alt="Descarga Excel" />
                </div>
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <span className="fs-3 text-gray-700 fw-bold">
                Resumen de Liquidación
              </span>
            </div>
            <div className="row">
            <div className={`col-12 table-responsive ${state.loading ? 'table-loading-overlay' : ''}`} >
              <table className="table table-bordered">
                <tbody className="fs-6 text-gray-800">
                {state.data_pago_consulta?.map((item, index) => (
                    <tr key={index}>
                      <td>{item.description}</td>
                      <td>{formatCurrency(item.valor)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          </div>
        </>
      )}
    </>
  )
}

export default QueryDetail